// File: src/pages/Cliente/ClienteList.jsx

import React, { useEffect, useState } from 'react';
import DataTable from '../../components/DataTablePtBr';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import api from '../../services/api';
import { showError, showSuccess, showConfirmation } from '../../services/alert';

const ClienteList = () => {
  const [clientes, setClientes] = useState([]);
  const navigate = useNavigate();

  const fetchClientes = () => {
    api.get('/cliente')
      .then(res => setClientes(res.data))
      .catch(() => showError('Erro ao buscar clientes.'));
  };

  useEffect(() => {
    fetchClientes();
  }, []);

  const handleDelete = async (id) => {
    const { isConfirmed } = await showConfirmation('Deseja realmente excluir este cliente?');
    if (!isConfirmed) return;
    api.delete(`/cliente/${id}`)
      .then(() => {
        showSuccess('Cliente removido com sucesso.');
        fetchClientes();
      })
      .catch(() => showError('Erro ao remover cliente.'));
  };

  const columns = [
    {
      name: 'Nome',
      selector: row => row.nome,
      sortable: true,
    },
    {
      name: 'Documento',
      selector: row => row.documento,
      sortable: true,
    },
    {
      name: 'Telefone',
      selector: row => row.telefone || '-',
    },
    {
      name: 'Email',
      selector: row => row.email || '-',
    },
    {
      name: 'Ações',
      cell: row => (
        <div className="d-flex gap-1">
          <button
            className="btn btn-outline-success btn-sm"
            onClick={() => navigate(`/cliente/${row.id}`)}
          >
            Editar
          </button>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => handleDelete(row.id)}
          >
            Excluir
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      minWidth: '160px',
      style: { whiteSpace: 'nowrap' }
    }
  ];

  return (
    <div className="container mt-4">
      <Header />
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-success text-white d-flex justify-content-between align-items-center rounded-top-3">
          <button
            className="btn btn-light btn-sm d-flex align-items-center gap-1"
            onClick={() => navigate('/menu')}
          >
            <i className="bi bi-arrow-left text-success"></i>
            <span className="text-success fw-semibold">Voltar</span>
          </button>
          <div>
            <h5 className="mb-0">Clientes</h5>
            <small className="text-white-50">Visualização dos clientes cadastrados</small>
          </div>
          <button
            className="btn btn-light text-success fw-bold d-flex align-items-center gap-1"
            onClick={() => navigate('/cliente/novo')}
          >
            <i className="bi bi-plus-circle"></i>
            <span>Novo</span>
          </button>
        </div>
        <div className="card-body">
          <DataTable
            columns={columns}
            data={clientes}
            pagination
            highlightOnHover
            striped
            noDataComponent={<div className="text-muted">Nenhum cliente encontrado.</div>}
          />
        </div>
      </div>
    </div>
  );
};

export default ClienteList;
